import ProductDescription from './ProductDescription'

const BreadProduct = {
  ...ProductDescription,
  category: '16',
  subCategory: '001',
  IsBroadband: true,
  BreadType: '',
  BreadSize: '16 ounces only',
}

export default BreadProduct
